import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendWorkplaceEnvironment } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendWorkplaceEnvironmentState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendWorkplaceEnvironmentInitialState: JobRecommendListForTrendWorkplaceEnvironmentState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendWorkplaceEnvironmentSlice = createSlice({
  name: 'jobRecommendListForTrendWorkplaceEnvironment',
  initialState: jobRecommendListForTrendWorkplaceEnvironmentInitialState,
  reducers: {
    setInitialDisplayFlagWorkplaceEnvironment: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendWorkplaceEnvironment.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(
      getJobListForTrendWorkplaceEnvironment.fulfilled,
      (state, action) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
        state.jobRecommendListForTrend.entity = action.payload;
      }
    );
    builder.addCase(
      getJobListForTrendWorkplaceEnvironment.rejected,
      (state) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
      }
    );
  },
});

// Create Action
export const { setInitialDisplayFlagWorkplaceEnvironment } =
  jobRecommendListForTrendWorkplaceEnvironmentSlice.actions;

// reducer
export const jobRecommendListForTrendWorkplaceEnvironmentsReducer =
  jobRecommendListForTrendWorkplaceEnvironmentSlice.reducer;

interface State {
  jobRecommendListForTrendWorkplaceEnvironment: JobRecommendListForTrendWorkplaceEnvironmentState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendWorkplaceEnvironmentLoadingSelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendWorkplaceEnvironment?.jobRecommendListForTrend
    .loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendWorkplaceEnvironmentEntitySelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendWorkplaceEnvironment?.jobRecommendListForTrend
    .entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagWorkplaceEnvironmentSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendWorkplaceEnvironment.initialDisplayFlag;
